var isOptionEqualToValue_matchId = function (option, value) { var _a, _b; return ((_a = option === null || option === void 0 ? void 0 : option.value) === null || _a === void 0 ? void 0 : _a.MatchId) === ((_b = value.value) === null || _b === void 0 ? void 0 : _b.MatchId); };
var isOptionEqualToValue_matchKey = function (option, value) { var _a, _b; return ((_a = option === null || option === void 0 ? void 0 : option.value) === null || _a === void 0 ? void 0 : _a.MatchKey) === ((_b = value.value) === null || _b === void 0 ? void 0 : _b.MatchKey); };
var isOnBlurValueEqualToSelectedValue = function (blurVal, val) {
    if (blurVal === "" && val === undefined) {
        return true;
    }
    if (blurVal === (val === null || val === void 0 ? void 0 : val.label)) {
        return true; //verify?
    }
    if (blurVal === val) {
        return true;
    }
    return false;
};
export { isOptionEqualToValue_matchId, isOptionEqualToValue_matchKey, isOnBlurValueEqualToSelectedValue };
//# sourceMappingURL=data-comparison-helpers.js.map